import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { ComPhoto, GoodsPhoto } from '../../../js/ComponentManager'
import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:도매별 문의리스트 마스터
 * 세부설명:
*/

export class QuestList extends Component {
    static displayName = QuestList.name;

    constructor(props) {
        super(props);
        this.Page_Size = Big3Common.WebConfig.Page_Size;
        this.state = {
            TotalCount: 0,
            StartPage: 1,
            EndPage: this.Page_Size,
            QstDtList: []
        };
        this.CsName = Big3Common.ContentState;
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallQstDtListData(this.state.StartPage, this.state.EndPage);
    }
    //주문문의 조회
    async CallQstDtListData(StartPage, EndPage) {
        try {

            Big3Common.Util.LoadingOn();
            let Paging = { startpage: StartPage, endpage: EndPage, page_size: this.Page_Size }
            let Data = await Big3Common.Post('api/Chat/ChatList/GetQstMgtList', Paging);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let CallList = JSON.parse(Data.multiDataTable);
                if (CallList.DataList !== null) {
                    let TotalCount = CallList.TotalCount;
                    let NowQstDtList = this.state.QstDtList;
                    CallList.DataList.map(list => NowQstDtList.push(list));
                    this.setState({ QstDtList: NowQstDtList, TotalCount: TotalCount });
                }
                
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstDtListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAdd_Click() {
        let StartPage = this.state.StartPage + this.Page_Size;
        let EndPage = this.state.EndPage + this.Page_Size;
        this.setState({ StartPage: StartPage, EndPage: EndPage });
        this.CallQstDtListData(StartPage, EndPage);
    }
    handleMove_Click(event, list) {

        this.props.RenderComponent('WhQuestList', { [this.CsName.Uid]: list.uid, [this.CsName.Whole_Name]: list.whole_name });
        event.preventDefault();
    }
    Listrender() {
        const QstDtList = this.state.QstDtList;
        return (
            <>
                {QstDtList.map(list =>
                    <div className="alert_content_v2 alert_content" key={list.rownum } onClick={(e) => { this.handleMove_Click(e,list) }}>
                        <div className="alert_img">
                            {
                                list.photo === null ?
                                    <GoodsPhoto className="alert_img_in" ImageSrc={list.img_100} />
                                    :
                                    <ComPhoto className="alert_img_in" Photo={list.photo} />
                            }
                        </div>
                        <div className="alert_txt">
                            <div className="shop_name">{list.whole_name}</div>
                            <div className="shop_address2">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>
                            <div className="alert_time">{list.qstdt} {list.conf_count === 0 ? "" : <div className="alert_new"></div>}</div>
                        </div>
                    </div>
                )}
            </>
        )
    }
    render() {
        let Listrender = this.Listrender();
        return (
            <>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap">
                        <div className="alert_tap  tap_on">주문문의</div>
                    </div>
                    <Link to="/Chat/LiveChat/LiveChatList">
                        <div className="n_tap">
                            <div className="alert_tap">
                                채팅문의
                                <sup>βeta</sup>
                            </div>
                        </div>
                    </Link>

                </div>
                <div className="m_f_margin d_padding container_box">
                    {Listrender}
                    <div className="more_button">
                        {
                            this.state.TotalCount > this.state.QstDtList.length ?
                                <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click}>더보기</button> : ""
                        }
                    </div>
                </div>
            </>
        );
        
    }
}
